import { NotebookIcon } from '@ui/kit/icons';
import { loadNotebookLibrary } from '@utils/common';
import { UniversalContextMenuButton } from '@utils/component-framework';
import { jsx } from 'react/jsx-runtime';

function NotebookButton(props) {
  const handleClick = async () => {
    const gNotebook = await loadNotebookLibrary();
    const newNoteId = await gNotebook.createNote({
      title: props.learningObjectTitle,
      context: {
        learningObject: {
          id: props.learningObjectId,
          title: props.learningObjectTitle,
          type: props.nodeType
        }
      }
    });
    gNotebook.requestOpen({
      noteId: newNoteId
    });
    props.onClick();
  };
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "button",
    label: "Opret note til indholdet",
    onClick: handleClick,
    icon: /*#__PURE__*/jsx(NotebookIcon, {}),
    async: true
  });
}

export { NotebookButton };
//# sourceMappingURL=notebook-button.js.map
